type PreferenceOption = "granted" | "denied"

interface GPCNavigator extends Navigator {
  globalPrivacyControl?: boolean
}

declare let navigator: GPCNavigator

interface CookieConsentPreferences {
  ad_user_data: PreferenceOption
  ad_personalization: PreferenceOption
  ad_storage: PreferenceOption
  analytics_storage: PreferenceOption
  functional_storage: PreferenceOption
  personalization_storage: PreferenceOption
  security_storage: PreferenceOption
}

export const gpcSignal = navigator.globalPrivacyControl || false

export default function getCookieConsentPreferences() {
  try {
    const rawPreferenceCookie = document.cookie
      .split(";")
      .find(c => c.includes("ca_mktg_cookie_consent_prefs"))

    const cookieConsentPreferences = rawPreferenceCookie
      ? (JSON.parse(
          decodeURIComponent(rawPreferenceCookie.trim().split("=")[1] ?? "")
        ) as CookieConsentPreferences)
      : null

    return cookieConsentPreferences
  } catch {
    return null
  }
}
